import React, { useState, useEffect } from "react";
import { MdSunny } from "react-icons/md";
import { BsMoonStarsFill } from "react-icons/bs";

const ThemeSwitchButton = () => {
  const savedMode = localStorage.getItem("darkMode") === "true";
  const [isDarkMode, setIsDarkMode] = useState(savedMode);

  const toggleMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem("darkMode", newMode);
  };

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
    } else {
      document.body.classList.add("light");
      document.body.classList.remove("dark");
    }
  }, [isDarkMode]);

  return (
    <>
      <button className="darklightbtn" onClick={toggleMode}>
        {isDarkMode ? <MdSunny /> : <BsMoonStarsFill />}
      </button>
    </>
  );
};

export default ThemeSwitchButton;
